import { Message } from "element-ui";

/**
 * 全局错误处理工具类
 */
export default class ErrorHandler {
  /**
   * 处理SDK错误
   * @param exception - 错误对象
   */
  static handleSDKError(exception: any): void {
    Message.error(exception?.message || "Unknown error");
  }
}
